import React from 'react';
import ErrorReportingService from '../services/ErrorReportingService';

class GlobalErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, error: null };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true, error };
  }

  componentDidCatch(error, errorInfo) {
    ErrorReportingService.captureError(error, {
      componentStack: errorInfo?.componentStack,
      source: 'error_boundary',
      severity: 'critical',
    });
  }

  handleRetry = () => {
    this.setState({ hasError: false, error: null });
  };

  handleGoHome = () => {
    this.setState({ hasError: false, error: null });
    window.location.href = '/dashboard';
  };

  render() {
    if (this.state.hasError) {
      return (
        <div style={{
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          justifyContent: 'center',
          minHeight: '100vh',
          padding: '32px',
          textAlign: 'center',
          fontFamily: '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif',
          background: 'var(--bg-primary, #f5f5f5)',
          color: 'var(--text-primary, #333)',
        }}>
          <div style={{
            background: 'var(--card-bg, #fff)',
            border: '1px solid var(--border-light, #ddd)',
            borderRadius: '12px',
            padding: '48px 40px',
            maxWidth: '520px',
            width: '100%',
            boxShadow: '0 2px 12px rgba(0,0,0,0.08)',
          }}>
            <div style={{ fontSize: '48px', marginBottom: '16px' }}>⚠️</div>
            <h1 style={{ fontSize: '24px', fontWeight: 600, marginBottom: '12px' }}>
              Something went wrong
            </h1>
            <p style={{ color: 'var(--text-muted, #888)', fontSize: '15px', marginBottom: '8px' }}>
              An unexpected error occurred. The error has been automatically reported.
            </p>
            {this.state.error?.message && (
              <p style={{
                fontFamily: 'monospace',
                fontSize: '13px',
                background: 'var(--bg-secondary, #f0f0f0)',
                padding: '12px',
                borderRadius: '6px',
                marginTop: '16px',
                color: 'var(--semantic-text-danger, #c00)',
                wordBreak: 'break-word',
                textAlign: 'left',
                maxHeight: '120px',
                overflow: 'auto',
              }}>
                {this.state.error.message}
              </p>
            )}
            <div style={{ display: 'flex', gap: '12px', justifyContent: 'center', marginTop: '28px' }}>
              <button
                onClick={this.handleRetry}
                style={{
                  padding: '10px 28px',
                  background: 'var(--action-primary-bg, #4a90e2)',
                  color: 'var(--action-primary-text, #fff)',
                  border: 'none',
                  borderRadius: '6px',
                  fontSize: '14px',
                  fontWeight: 500,
                  cursor: 'pointer',
                }}
              >
                🔄 Try Again
              </button>
              <button
                onClick={this.handleGoHome}
                style={{
                  padding: '10px 28px',
                  background: 'transparent',
                  color: 'var(--text-secondary, #666)',
                  border: '1px solid var(--border-light, #ddd)',
                  borderRadius: '6px',
                  fontSize: '14px',
                  fontWeight: 500,
                  cursor: 'pointer',
                }}
              >
                Go to Dashboard
              </button>
            </div>
          </div>
        </div>
      );
    }

    return this.props.children;
  }
}

export default GlobalErrorBoundary;
